import { Box, Stack } from "@mui/material";
import React from "react";

const Content = ({ title, text, className }) => {
  return (
    <Stack className={className}>
      <Box
        sx={{
          fontWeight: 900,
          fontSize: "30px",
          color: "#6a27e8",
          my: "22px",
        }}
        dangerouslySetInnerHTML={{ __html: title?.html }}
      />

      <Box
        sx={{
          color: "#2b2a28",
          "& h1": {
            fontWeight: 900,
            fontSize: "30px",
            color: "#6a27e8",
            my: "22px",
          },
          "& h2": {
            fontWeight: 900,
            fontSize: "28px",
            color: "#6a27e8",
            my: "20px",
          },
          "& h3": {
            fontWeight: 900,
            fontSize: "26px",
            color: "#6a27e8",
            my: "19px",
          },
          "& h4": {
            fontWeight: 900,
            fontSize: "24px",
            color: "#6a27e8",
            my: "21px",
          },
          "& h5": {
            fontWeight: 900,
            fontSize: "22px",
            color: "#6a27e8",
            my: "22px",
          },
          "& h6": {
            fontWeight: 900,
            fontSize: "20x",
            color: "#6a27e8",
            my: "25px",
          },
          "& p": {
            my: "16px",
          },
          "& p strong": {
            color: "#6a27e8",
          },
          "& ul": {
            display: "block",
            listStyleType: "disc",
            mt: "1em",
            mb: "1em",
            pl: "40px",
          },
          "& ol": {
            display: "block",
            listStyleType: "decimal",
            mt: "1em",
            mb: "1em",
            pl: "40px",
          },
          "& .block-img": {
            display: "flex",
            justifyContent: "center",
            "& img": { width: "50%", height: "50%" },
          },
        }}
        dangerouslySetInnerHTML={{ __html: text?.html }}
      />
    </Stack>
  );
};

export default Content;
